"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-row", {
    staticClass: "dispatch-row",
    attrs: {
      gutter: 20,
      type: "flex"
    }
  }, [_c("el-col", {
    attrs: {
      xs: 8,
      sm: 7,
      md: 7,
      lg: 6,
      xl: 5
    }
  }, [_c("div", {
    staticClass: "left-panel"
  }, [_c("el-card", {
    staticClass: "box-card"
  }, [_c("div", {
    staticClass: "clearfix",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("span", [_vm._v("Dispatch Details")])]), _c("div", {
    staticClass: "form-container"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules,
      "label-position": "top",
      size: "small"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Unit Manager",
      prop: "adminId"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      placeholder: "Select Unit Manager",
      disabled: _vm.isEdit || _vm.loggedInAdmin.roles.includes("Unit Manager")
    },
    on: {
      change: _vm.fetchUnitList
    },
    model: {
      value: _vm.formData.adminId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "adminId", $$v);
      },
      expression: "formData.adminId"
    }
  }, _vm._l(_vm.unitManagers, function (admin) {
    return _c("el-option", {
      key: admin.id,
      attrs: {
        label: admin.fullName,
        value: admin.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Unit",
      prop: "unitId"
    }
  }, [_c("el-select", {
    staticClass: "filter-item",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      clearable: "",
      filterable: "",
      placeholder: "Select Unit",
      disabled: _vm.isEdit
    },
    on: {
      change: _vm.dealerOrUnitChanged
    },
    model: {
      value: _vm.formData.unitId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "unitId", $$v);
      },
      expression: "formData.unitId"
    }
  }, _vm._l(_vm.unitList, function (unit) {
    return _c("el-option", {
      key: unit.id,
      attrs: {
        label: unit.name,
        value: unit.id
      }
    }, [_vm._v(" " + _vm._s(unit.name) + " - " + _vm._s(unit.code) + " ")]);
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Dealer",
      prop: "dealerId"
    }
  }, [_c("el-select", {
    staticClass: "filter-item",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      clearable: "",
      filterable: "",
      remote: "",
      "reserve-keyword": "",
      "remote-method": _vm.getDealerList,
      loading: _vm.dealerLoading,
      placeholder: "Select Dealer",
      disabled: _vm.isEdit
    },
    on: {
      change: _vm.dealerOrUnitChanged
    },
    model: {
      value: _vm.formData.dealerId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "dealerId", $$v);
      },
      expression: "formData.dealerId"
    }
  }, _vm._l(_vm.dealerList, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: dealer.name,
        value: dealer.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "14px"
      }
    }, [_vm._v(" " + _vm._s(dealer.name) + " - " + _vm._s(dealer.code) + " ")]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "14px"
      }
    }, [_vm._v("   | ID: " + _vm._s(dealer.id) + " ")])]);
  }), 1), _vm.dealerAddress ? _c("el-tag", {
    staticStyle: {
      "margin-top": "5px",
      "white-space": "normal",
      height: "auto",
      "line-height": "1.5",
      width: "100%"
    },
    attrs: {
      type: "info"
    }
  }, [_c("i", {
    staticClass: "el-icon-location-outline"
  }), _vm._v(" " + _vm._s(_vm.dealerAddress) + " ")]) : _vm._e()], 1), _c("el-form-item", {
    attrs: {
      label: "Transporter",
      prop: "dealersTransporterId"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      filterable: "",
      placeholder: "Select Transporter"
    },
    on: {
      change: _vm.onTransporterChange
    },
    model: {
      value: _vm.formData.dealersTransporterId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "dealersTransporterId", $$v);
      },
      expression: "formData.dealersTransporterId"
    }
  }, _vm._l(_vm.transporterList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.transporter.name,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "Private Marka",
      prop: "privateMarka"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.formData.privateMarka,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "privateMarka", $$v);
      },
      expression: "formData.privateMarka"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Dispatch Date",
      prop: "dispatchDate"
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "date",
      placeholder: "Select Date",
      format: "dd-MM-yyyy",
      "picker-options": {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    },
    model: {
      value: _vm.formData.dispatchDate,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "dispatchDate", $$v);
      },
      expression: "formData.dispatchDate"
    }
  })], 1), _vm.hasVehicleNumber ? _c("el-form-item", {
    attrs: {
      label: "Vehicle Number",
      prop: "vehicleNumber",
      required: ""
    }
  }, [_c("el-input", {
    model: {
      value: _vm.formData.vehicleNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "vehicleNumber", $$v);
      },
      expression: "formData.vehicleNumber"
    }
  }), _c("small", {
    staticStyle: {
      color: "#909399",
      "font-size": "11px"
    }
  }, [_vm._v(" E-way bill will be generated with this vehicle number. ")])], 1) : _vm._e(), _vm.formData.dealerId && _vm.hasSeparateAddress ? _c("el-form-item", {
    attrs: {
      label: "Billing Address",
      prop: "billingAddressId"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: "Select Billing Address"
    },
    model: {
      value: _vm.formData.billingAddressId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "billingAddressId", $$v);
      },
      expression: "formData.billingAddressId"
    }
  }, _vm._l(_vm.addressList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "11px"
      }
    }, [_vm._v(_vm._s(_vm.getFullAddress(item)))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "11px"
      }
    }, [_vm._v("   | ID: " + _vm._s(item.id) + " "), item.isPrimary ? _c("el-tag", {
      attrs: {
        type: "success",
        size: "mini"
      }
    }, [_vm._v(" Primary ")]) : _vm._e(), item.isPostal ? _c("el-tag", {
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        type: "primary",
        size: "mini"
      }
    }, [_vm._v(" Postal ")]) : _vm._e()], 1)]);
  }), 1)], 1) : _vm._e(), _vm.formData.dealerId && _vm.hasSeparateAddress ? _c("el-form-item", {
    attrs: {
      label: "Shipping Address",
      prop: "deliveryAddressId"
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: "Select Shipping Address"
    },
    model: {
      value: _vm.formData.deliveryAddressId,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "deliveryAddressId", $$v);
      },
      expression: "formData.deliveryAddressId"
    }
  }, _vm._l(_vm.addressList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "11px"
      }
    }, [_vm._v(_vm._s(_vm.getFullAddress(item)))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "11px"
      }
    }, [_vm._v("   | ID: " + _vm._s(item.id) + " "), item.isPrimary ? _c("el-tag", {
      attrs: {
        type: "success",
        size: "mini"
      }
    }, [_vm._v(" Primary ")]) : _vm._e(), item.isPostal ? _c("el-tag", {
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        type: "primary",
        size: "mini"
      }
    }, [_vm._v(" Postal ")]) : _vm._e()], 1)]);
  }), 1)], 1) : _vm._e(), _c("el-row", {
    attrs: {
      gutter: 15
    }
  }, [_c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Narrations",
      prop: "comments"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 3
    },
    model: {
      value: _vm.formData.comments,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "comments", $$v);
      },
      expression: "formData.comments"
    }
  })], 1)], 1)], 1), _c("el-row", {
    attrs: {
      gutter: 15
    }
  }, [_c("el-col", {
    attrs: {
      span: 24
    }
  }, [_c("el-form-item", {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c("el-popconfirm", {
    attrs: {
      title: "Are you sure to dispatch?"
    },
    on: {
      confirm: _vm.submitForm
    }
  }, [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    staticStyle: {
      width: "100%"
    },
    attrs: {
      slot: "reference",
      disabled: _vm.quantityToSettle === 0,
      type: "success"
    },
    slot: "reference"
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")])], 1)], 1)], 1)], 1)], 1)], 1)]), _vm.order ? _c("el-card", {
    staticClass: "box-card",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c("div", {
    staticClass: "clearfix",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("span", [_vm._v("Order Details")])]), _c("div", {
    staticClass: "text item"
  }, [_vm._v(" ID: " + _vm._s(_vm.order.id) + " ")]), _c("div", {
    staticClass: "text item"
  }, [_vm._v(" Reference: " + _vm._s(_vm.order.orderReference) + " ")]), _c("div", {
    staticClass: "text item"
  }, [_vm._v(" Qty Ordered: " + _vm._s(_vm.order.totalQuantity) + " ")]), _c("div", {
    staticClass: "text item"
  }, [_vm._v(" Qty Dispatched: " + _vm._s(_vm.order.totalQuantityDispatched) + " ")])]) : _vm._e()], 1)]), _c("el-col", {
    attrs: {
      xs: 16,
      sm: 17,
      md: 17,
      lg: 18,
      xl: 19
    }
  }, [_c("el-card", {
    staticClass: "box-card products-card"
  }, [_c("div", {
    staticClass: "clearfix products-card-header",
    attrs: {
      slot: "header"
    },
    slot: "header"
  }, [_c("span", [_vm._v("Products")]), _c("span", {
    staticClass: "products-summary"
  }, [_vm._v(" Items: " + _vm._s(_vm.ordersProductsDispatch.length) + "  |  Total Qty: " + _vm._s(_vm.quantityToSettle) + "  |  Total Carton(s): " + _vm._s(_vm.totalCartons) + " ")])]), _c("div", {
    ref: "topScroller",
    staticClass: "table-top-scroller",
    on: {
      scroll: _vm.syncTableScroll
    }
  }, [_c("div", {
    staticClass: "top-scroller-track"
  })]), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.ordersProductsListLoading,
      expression: "ordersProductsListLoading"
    }],
    key: _vm.tableKey,
    ref: "ordersProductsDispactchesTable",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      size: "small",
      data: _vm.ordersProductsDispatch,
      border: "",
      fit: "",
      height: "calc(100vh - 280px)",
      "row-class-name": _vm.rowClassName,
      "empty-text": "Select Unit and Dealer to load products"
    },
    on: {
      scroll: _vm.syncTopScroller
    }
  }, [_c("el-table-column", {
    attrs: {
      "min-width": "50",
      align: "left",
      label: "SNo"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.$index + 1) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "180",
      align: "left",
      label: "Product",
      prop: "productId"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.product.name) + " "), _c("br")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      "min-width": "90",
      align: "left",
      label: "Color",
      prop: "productsVariationId"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.product.name === scope.row.productsVariation.name ? "-" : scope.row.productsVariation.name) + " "), _c("br")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Quantity",
      align: "center"
    }
  }, [_c("el-table-column", {
    attrs: {
      "min-width": "80",
      align: "right",
      label: "Ordered",
      prop: "quantityOrdered"
    }
  }), _c("el-table-column", {
    attrs: {
      "min-width": "80",
      align: "right",
      label: "Dispatched",
      prop: "quantityDispatched"
    }
  }), _c("el-table-column", {
    attrs: {
      "min-width": "80",
      align: "right",
      label: "Pending",
      prop: "quantityPending"
    }
  }), _c("el-table-column", {
    attrs: {
      "min-width": "80",
      align: "right",
      label: "Available",
      prop: "quantityAvailable"
    }
  }), _c("el-table-column", {
    attrs: {
      "min-width": "175",
      align: "left",
      label: "Adjusted"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-input-number", {
          staticStyle: {
            width: "160px"
          },
          attrs: {
            disabled: !scope.row.quantityAvailable || scope.row.quantityAvailable < scope.row.product.piecesPerBox,
            size: "small",
            "controls-position": "right",
            min: 0,
            precision: 0,
            max: scope.row.quantityPending > scope.row.quantityAvailable ? scope.row.quantityAvailable : scope.row.quantityPending,
            step: scope.row.product.piecesPerBox
          },
          on: {
            change: function ($event) {
              return _vm.quantityUpdated(scope.row);
            }
          },
          model: {
            value: scope.row.quantity,
            callback: function ($$v) {
              _vm.$set(scope.row, "quantity", $$v);
            },
            expression: "scope.row.quantity"
          }
        })];
      }
    }])
  })], 1), _c("el-table-column", {
    attrs: {
      "min-width": "65",
      align: "right",
      label: "CR",
      prop: "totalCartonCount"
    }
  })], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;